import styled from "@emotion/styled";
import { Col, Row } from "antd";
import { useState } from "react";
import { useAppSelector } from "store";
import { SellerReportPeriod } from "services/interface/sellerReport.interface";
import { useSellerTodoSummary } from "hooks/useSellerReport";
import DashboardHeader from "./header/DashboardHeader";
import KpiRow from "./kpi/KpiRow";
import TodoPanel from "./todo/TodoPanel";
import SalesTrendCard from "./charts/SalesTrendCard";
import OrderStatusCard from "./charts/OrderStatusCard";
import TopProductsCard from "./bottom/TopProductsCard";
import RepeatCustomerCard from "./bottom/RepeatCustomerCard";
import PayoutCard from "./bottom/PayoutCard";

/**
 * หน้า "ภาพรวมร้านค้า" — ดึงข้อมูลจาก /factory/seller-report/*
 *
 * period เก็บเป็น state เดียวที่นี่ แล้วส่งให้ทั้ง dropdown บนหัวและ Segmented ในการ์ดกราฟ
 * (สองตัวคุมค่าเดียวกัน) เพราะ label ช่วงวันที่บนหัวต้องตรงกับสิ่งที่กราฟแสดง
 * และยอดขายสุทธิใน KPI กับ total ของกราฟมาจากหน้าต่างเวลาเดียวกัน
 */
const SellerDashboard = () => {
  const [period, setPeriod] = useState<SellerReportPeriod>("7d");
  const { profile } = useAppSelector((state) => state.auth);

  // query key เดียวกับใน TodoPanel — React Query dedupe ให้ ยิงจริงครั้งเดียว
  const { data: todo } = useSellerTodoSummary();

  return (
    <Page>
      <DashboardHeader
        name={profile?.user?.first_name}
        newOrderCount={todo?.new_orders_to_prepare}
        period={period}
        onPeriodChange={setPeriod}
      />

      <Section>
        <KpiRow period={period} />
      </Section>

      <Section>
        <TodoPanel />
      </Section>

      <Section>
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={16}>
            <SalesTrendCard period={period} onPeriodChange={setPeriod} />
          </Col>
          <Col xs={24} lg={8}>
            <OrderStatusCard period={period} />
          </Col>
        </Row>
      </Section>

      <Section>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} xl={8}>
            <TopProductsCard period={period} />
          </Col>
          <Col xs={24} md={12} xl={8}>
            <RepeatCustomerCard period={period} />
          </Col>
          <Col xs={24} md={24} xl={8}>
            <PayoutCard />
          </Col>
        </Row>
      </Section>
    </Page>
  );
};

export default SellerDashboard;

const Page = styled.div`
  width: 100%;
`;

const Section = styled.div`
  margin-top: 20px;
`;
